import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useProjects } from '../../context/ProjectContext';
import Container from '../../layouts/Container';
import { Tabs, Tab } from 'react-bootstrap';
import DistributionsPage from './Distributions';
import InventoryTabContent from './InventoryTabContent';

const InventoryPage = () => {
  const [activeTab, setActiveTab] = useState('inventory');
  const { projectId } = useParams();
  const { projects } = useProjects();
  const project = projects.find(p => p.id === Number(projectId));
  const hasInventory = project?.settings?.inventory === true;

  if (!hasInventory) return null;

  return (
    <Container>
      <Tabs activeKey={activeTab} onSelect={setActiveTab} className="mb-3">
        <Tab eventKey="inventory" title="Inventory">
          <InventoryTabContent projectId={projectId} />
        </Tab>
        <Tab eventKey="distributions" title="Distributions">
          <DistributionsPage />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default InventoryPage;
